import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.rolesReady;

    const user = authService.getCurrentUser();

    if (!user) {
        router.navigate(['/login']);
        return false;
    }

    if (
        user.hasDefaultPassword === true &&
        state.url !== '/settings/change-password'
    ) {
        router.navigate(['/settings/change-password']);
        return false;
    }

    if (
        user.hasDefaultPassword === false &&
        state.url === '/settings/change-password'
    ) {
        router.navigate(['/home']);
        return false;
    }

    return true;
};
